import React from "react";
import {
  CompareProductButton,
  ListOutletButton,
  GridOutletOrQuoteButton,
  ListQuoteButton,
  CustomizableButton,
  DefaultButton,
  CustomizableListButton,
} from "./ButtonVariations";
import { Product } from "~/common/Store/models/ProductListing";
import { ProductListingView } from ".";

export interface ProductBoxType {
  isCarouselProductBox: boolean;
  isCompareWithProductBox: boolean;
  isCustomizeNowProductBox: boolean;
}

const ButtonWrapper = ({
  children,
  product,
  productBoxType,
  productListingView,
  width,
  displayRequiredCustomization,
  hasCustomizableProductsOverride,
  isOutlet,
}: {
  children: React.ReactNode;
  product: Product;
  productBoxType: ProductBoxType;
  productListingView: ProductListingView;
  width: number;
  displayRequiredCustomization: boolean;
  hasCustomizableProductsOverride: boolean;
  isOutlet: boolean;
}) => {
  if (productBoxType.isCompareWithProductBox) {
    return <CompareProductButton>{children}</CompareProductButton>;
  }

  if (productListingView === "list" && isOutlet) {
    return <ListOutletButton width={width}>{children}</ListOutletButton>;
  }

  if (productBoxType.isCustomizeNowProductBox) {
    if (productListingView === "list") {
      return <CustomizableListButton>{children}</CustomizableListButton>;
    }

    return <CustomizableButton>{children}</CustomizableButton>;
  }

  if (
    productListingView === "grid" &&
    (isOutlet || product.isRequestAQuoteEnabled)
  ) {
    return <GridOutletOrQuoteButton>{children}</GridOutletOrQuoteButton>;
  }

  if (productListingView === "list" && product.isRequestAQuoteEnabled) {
    return <ListQuoteButton>{children}</ListQuoteButton>;
  }

  const usesCustomizableButton =
    hasCustomizableProductsOverride || displayRequiredCustomization;

  const shouldNotHavePadding =
    productBoxType.isCarouselProductBox &&
    (product.mustPurchaseMoreThanOne ||
      product.isRequestAQuoteEnabled ||
      usesCustomizableButton);

  if (shouldNotHavePadding) {
    return <CustomizableButton>{children}</CustomizableButton>;
  }

  return <DefaultButton>{children}</DefaultButton>;
};

export default ButtonWrapper;
